const orange300Color = '#f2c479';

export default orange300Color;
